module.exports = __webpack_public_path__ + "img/11.fbf55f6a.jpg";